import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: () => ({
    '&&': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      outline: 'none',
      display: 'flex',
      flexDirection: 'column',
    },
  }),
  closeButton: {
    '&&': {
      borderRadius: '50%',
      position: 'absolute',

      [theme.breakpoints.down('tablet')]: {
        top: 0,
        right: 0,
      },
      [theme.breakpoints.up('tablet')]: {
        top: 4,
        right: 4,
      },
    },
  },
  title: {
    margin: 0,
    textAlign: 'center',

    fontSize: FONTS.SIZES.xxl,
    fontWeight: FONTS.WEIGHTS.bold,
  },
}))
